import anime from "animejs";

export function popOut(elementId: string) {
  anime
    .timeline({ autoplay: false })
    .add({
      targets: elementId,
      duration: 100,
      translateX: 4,
      translateY: -4,
      easing: "easeOutSine",
    })
    .play();
}

export function popIn(elementId: string) {
  anime
    .timeline({ autoplay: false })
    .add({
      targets: elementId,
      duration: 100,
      translateX: 0,
      translateY: 0,
      easing: "easeInSine",
    })
    .play();
}
